import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-action-icon-button',
  templateUrl: './action-icon-button.component.html',
  styleUrl: './action-icon-button.component.scss',
  standalone: false,
})
export class ActionIconButtonComponent {
  icon = input.required<string>();
  type = input<'edit' | 'delete'>('edit');
  disabled = input<boolean>(false);

  handleClick = output<MouseEvent>();

  onClick(event: MouseEvent) {
    this.handleClick.emit(event);
  }
}
